import { AnswerType } from '../../shared/enums/answer.enum';
import { Answer } from './answer.model';

// @dynamic
export type ReadingQuestionAnswer = boolean;

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class ReadingAnswer extends Answer {
  public answer: ReadingQuestionAnswer | undefined;

  constructor(id: string, type: AnswerType, answer?: ReadingQuestionAnswer) {
    super();
    this.id = id;
    this.type = type;
    this.answer = answer;
  }

  public static fromDto(dto: any): ReadingAnswer {
    return new ReadingAnswer(dto.id, dto.type, dto.answer);
  }
}
